<!-- <gp-letters-table-filters></gp-letters-table-filters>-->
<gp-letters-filters
  [statusId]="GpAddressStatus.verified"
  [verified]="GpAddressVerifiedStatus.verified"
  (filterChanged)="onFilterChanged($event)"
></gp-letters-filters>
<div>
  @if (dataSource.data.length) {
    <ng-container *ngTemplateOutlet="paginatorComponent"></ng-container>
  }
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-striped">
    <ng-container matColumnDef="visit">
      <th mat-header-cell *matHeaderCellDef class="th">Visit</th>
      <div class="td" mat-cell *matCellDef="let element">
        {{ element.visit_id }}
      </div>
    </ng-container>
    <ng-container matColumnDef="service">
      <th mat-header-cell *matHeaderCellDef class="th">Service</th>
      <div class="td" mat-cell *matCellDef="let element">
        {{ element.service }}
      </div>
    </ng-container>
    <ng-container matColumnDef="medications">
      <th mat-header-cell *matHeaderCellDef class="th">Medication</th>
      <div class="td" mat-cell *matCellDef="let element">{{ element.medications.join(', ') }}</div>
    </ng-container>
    <ng-container matColumnDef="gp_address">
      <th mat-header-cell *matHeaderCellDef class="th">GP Address</th>
      <div class="td" mat-cell *matCellDef="let element">
        {{ getFullAddress(element) }}
      </div>
    </ng-container>
    <ng-container matColumnDef="visit_completed">
      <th mat-header-cell *matHeaderCellDef class="th">Visit completed</th>
      <div class="td" mat-cell *matCellDef="let element">
        {{ element.created | timeAgo }}
      </div>
    </ng-container>
    <ng-container matColumnDef="print">
      <th mat-header-cell *matHeaderCellDef class="th">
        <span>
          <button class="table-btn" (click)="printLetters(dataSource)" [disabled]="selectedItemsQty === 0">
            Print selected
          </button>
        </span>
      </th>
      <div class="td" mat-cell *matCellDef="let element">
        <span>
          <button (click)="printLetters(dataSource, element)" class="table-btn">Print</button>
        </span>
      </div>
    </ng-container>
    <ng-container matColumnDef="markSelectAsPrinted">
      <th mat-header-cell *matHeaderCellDef class="th">
        <span>
          <button class="table-btn" (click)="maskAsPrintedLetters(dataSource)" [disabled]="selectedItemsQty === 0">
            Mark Selected as Printed
          </button>
        </span>
      </th>
      <div class="td" mat-cell *matCellDef="let element">
        <span>
          @if (!element.printed) {
            <button (click)="maskAsPrintedLetters(dataSource, element)" class="table-btn">Mark as printed</button>
          } @else {
            <mat-icon>check</mat-icon>
          }
        </span>
      </div>
    </ng-container>
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef class="th">
        <input
          class="batch-checkbox"
          type="checkbox"
          [checked]="allItemsSelected"
          [indeterminate]="!allItemsSelected && selectedItemsQty"
          (change)="selectAllElement(dataSource)"
        />
      </th>
      <div class="td" mat-cell *matCellDef="let element">
        <input
          class="batch-checkbox"
          type="checkbox"
          [checked]="element.selected"
          (click)="selectItem(dataSource, element)"
        />
      </div>
    </ng-container>

    <tr class="tr" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="tr" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-items-container"><span>No data avaliable</span></div>
      </td>
    </tr>
  </table>
  @if (dataSource.data.length > 5) {
    <ng-container *ngTemplateOutlet="paginatorComponent"></ng-container>
  }
</div>

<ng-template #paginatorComponent>
  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="paginator.pageSize"
    [length]="paginator.length"
    [pageIndex]="paginator.pageIndex"
    showFirstLastButtons
    (page)="handlePageEvent($event)"
  ></mat-paginator>
</ng-template>
